import { FormMode } from 'common/constants/enums';
import { BuilderVersion } from 'common/interfaces/page-builder';
import { AggPageFormState } from 'context/page-form-context';
import { AggPageState } from 'context/pages-context';
import { useSearchParams } from 'react-router-dom';

import { PageTitle } from '../../../common/partials/PageTitle/PageTitle';
import { PageForm } from '../../page-form/page-form';
import { UpdateWrapper } from '../../update-wrapper/UpdateWrapper';
import { PageBuilderV2 } from '../page-builder-v2';

interface Props {
  builderVersion?: BuilderVersion
}

export const UpdatePage = ({ builderVersion = BuilderVersion.V1 }: Props) => {
  const [params] = useSearchParams();
  const formMode = params.get('mode') as FormMode;
  const pageTitle = formMode === FormMode.DUPLICATE ? 'Create page duplicate' : 'Update page';

  return (
    <div className="flex-column">
      {builderVersion === BuilderVersion.V1 && (
        <div className="d-flex align-center mb-20">
          <PageTitle title={pageTitle} withReturn />
        </div>
      )}
      {builderVersion === BuilderVersion.V2 && <PageBuilderV2 formMode={FormMode.UPDATE} isV2Enabled />}
      {builderVersion === BuilderVersion.V1 &&
        <AggPageState>
          <AggPageFormState>
            <UpdateWrapper>
              <PageForm components={['brandSelect', 'productContent']} formMode={formMode || FormMode.UPDATE} />
            </UpdateWrapper>
          </AggPageFormState>
        </AggPageState>}
    </div>
  );
};
